// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BenefitBlockWrapper-module--wrapper--2OMQY"};